const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'SET_PLAN':
      return { ...state, ...action.plan };
    case 'CLEAR_PLAN':
      return initialState;
    default:
      return state;
  }
}
